import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import DuplicateProduct from "./DuplicateProduct.graphql";
import { products } from "../../modules/api";

export default function useDuplicateProduct() {
    return useMutation(
        gql(DuplicateProduct),
        {
            client: products,
        },
    );
}
